import {
  componentName,
  ButtonSelectionGroupInternalClass,
} from './ButtonSelectionGroupInternalClass';

customElements.define(componentName, ButtonSelectionGroupInternalClass);

export { ButtonSelectionGroupInternalClass };
